import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

/**
 * Redirects legacy /customer/reporting to /customer/reporting-v2
 * Preserves all query parameters (organizationId, account_type, etc.)
 */
export const legacyReportingRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  return router.createUrlTree(['/customer/reporting-v2'], {
    queryParams: route.queryParams,
  });
};
